module.exports = __webpack_public_path__ + "img/red.cd0083a4.svg";